(function () {
  function showFilledAccordions() {
    document.querySelectorAll('accordion-custom').forEach(wrapper => {
      const heading = wrapper.querySelector('summary');
      const content = wrapper.querySelector('#details-content, .details-content');
      
      const headingText = heading ? heading.innerText.trim() : '';
      const contentText = content ? content.innerText.trim() : '';
      
      if (headingText === '' && contentText === '') {
        wrapper.style.display = 'none';
      } else {
        wrapper.style.display = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', showFilledAccordions);
})();
